import logo from './logo.png'
import banner from './banner.png'

export const theme = {
    color: {
      primary: "#179C7D",
      primaryHover: "#12755e",
    },
    logoImage: logo,
    backend: "https://fokus-fraunhofer.epaper-publishing-one.de/",
    directory: "/kiosk",
    header: {
      customer: "",
      title: "Fraunhofer FOKUS",
      image: banner
    },
    info: [{
      text: 'Impressum',
      link: 'https://www.fokus.fraunhofer.de/9663f8cb2d267d4b'
    },
    {
      text: 'Datenschutz',
      link: 'https://www.fokus.fraunhofer.de/cb51ccfe497c9fb4'
    }]
  };